import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { Spinner } from "./Spinner";
import "./Button.css";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "ghost"
  | "danger"
  | "danger-ghost"
  | "ghost-danger"
  | "ghost-primary"
  | "ghost-warn";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  iconStart?: ReactNode;
  iconEnd?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "primary", size = "md", loading, iconStart, iconEnd, children, disabled, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      className={`pr-btn pr-btn--${variant} pr-btn--${size}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <Spinner size={size === "lg" ? 18 : 14} /> : iconStart}
      <span>{children}</span>
      {!loading && iconEnd}
    </button>
  );
});
